module.exports = __webpack_public_path__ + "static/media/schedule.f6f1d86f.svg";